import type { FormSubmissionDto } from "../types/submission";
import { normalizeExternalSubmission } from "../lib/forms/externalSubmission";
import { apiRequest } from "./client";

/**
 * GET /api/v1/submissions/{uuid}
 * Authorization: Bearer {serviceToken}
 * Query не используется. Только чтение.
 */
export function fetchSubmissionByUuid(
  uuid: string,
  token: string,
): Promise<FormSubmissionDto> {
  return apiRequest<unknown>(
    `/api/v1/submissions/${encodeURIComponent(uuid)}`,
    {
      auth: false,
      bearerToken: token,
      skipUnauthorizedHandler: true,
    },
  ).then((body) => {
    const submission = normalizeExternalSubmission(body);
    if (!submission) {
      throw new Error("Invalid submission response");
    }
    return submission;
  });
}
